var _a;
var baseUrl = (_a = window === null || window === void 0 ? void 0 : window.App) === null || _a === void 0 ? void 0 : _a.baseUrl;
/**
 * All API routes used in the application. This is used to make sure that the
 * routes are consistent throughout the application.
 */
var apiRoutes = {
    signin: "".concat(baseUrl, "api/signin"),
    me: "".concat(baseUrl, "api/me"),
    logout: "".concat(baseUrl, "api/logout"),
    password: {
        email: "".concat(baseUrl, "api/password/email"),
        reset: "".concat(baseUrl, "api/password/reset"),
    },
    profile: {
        certificate: "".concat(baseUrl, "api/profile/certificate"),
        update: "".concat(baseUrl, "api/profile/update"),
        locale: "".concat(baseUrl, "api/profile/locale"),
    },
    companies: {
        index: "".concat(baseUrl, "api/companies"),
        connected: "".concat(baseUrl, "api/companies/connected"),
        update: "".concat(baseUrl, "api/companies/:company"),
        destroy: "".concat(baseUrl, "api/companies/:company"),
        credits: "".concat(baseUrl, "api/companies/:company/credits"),
        workers: "".concat(baseUrl, "api/companies/:company/workers"),
    },
    instructions: {
        index: "".concat(baseUrl, "api/instructions"),
    },
    locations: {
        index: "".concat(baseUrl, "api/locations/:company"),
        store: "".concat(baseUrl, "api/locations/:company"),
        update: "".concat(baseUrl, "api/locations/:location"),
        destroy: "".concat(baseUrl, "api/locations/:location"),
        workers: "".concat(baseUrl, "api/locations/:location/workers"),
    },
    sublocations: {
        index: "".concat(baseUrl, "api/sublocations/:location"),
        store: "".concat(baseUrl, "api/sublocations/:location"),
        update: "".concat(baseUrl, "api/sublocations/:sublocation"),
        destroy: "".concat(baseUrl, "api/sublocations/:sublocation"),
    },
    removals: {
        index: "".concat(baseUrl, "api/removals"),
    },
    inspections: {
        index: "".concat(baseUrl, "api/inspections"),
        store: "".concat(baseUrl, "api/inspections"),
        update: "".concat(baseUrl, "api/inspections/:report"),
        complete: "".concat(baseUrl, "api/inspections/complete/:report"),
        sync: "".concat(baseUrl, "api/inspections/sync/:report"),
        stop: "".concat(baseUrl, "api/inspections/stop/:report"),
        image: {
            store: "".concat(baseUrl, "api/inspections/image/:answer"),
            destroy: "".concat(baseUrl, "api/inspections/image/:answer"),
            pushToBucket: "".concat(baseUrl, "api/inspections/image/:answer/push-to-bucket"),
        },
        certificate: "".concat(baseUrl, "api/inspections/certificate")
    },
    questionaires: {
        index: "".concat(baseUrl, "api/questionaires"),
        generateReport: "".concat(baseUrl, "api/questionaires/generate-reports"),
    },
    terms: {
        check: "".concat(baseUrl, "api/terms/check"),
        accept: "".concat(baseUrl, "api/terms/accept/:term"),
    },
    jobs: {
        check: "".concat(baseUrl, "api/jobs/:jobId"),
    },
    certificates: {
        all: "".concat(baseUrl, "api/certificates"),
    },
    reports: {
        scheduled: "".concat(baseUrl, "api/reports/scheduled"),
    }
};
export default apiRoutes;
